import {loadingLock} from "./loading-lock.js";
import {fetchDownloads} from "./fetch-downloads.js";
import {renderDownload} from "./render-download.js";
export const initializeLoadMoreFormHandler = (contentElement) => {
  const form = contentElement.querySelector("form.download-list__load-more-form");
  const itemWrapper = contentElement.querySelector(".download-list__load-more-item-wrapper");
  const totalCount = parseInt(form.dataset.count);
  const itemsVisible = () => itemWrapper.childElementCount;
  const updateFormVisibility = () => {
    form.hidden = itemsVisible() >= totalCount;
  };
  const loading = loadingLock((isLoading) => {
    for (const submit of form.querySelectorAll('[type="submit"]')) {
      submit.disabled = isLoading;
    }
  });
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (!loading.acquire()) {
      return;
    }
    const downloads = await fetchDownloads(form, itemsVisible());
    for (const download of downloads) {
      itemWrapper.append(renderDownload(download));
    }
    updateFormVisibility();
    loading.release();
  });
  updateFormVisibility();
};
